exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".nus-1{fill:#cfd3db;}\n.nus-2,.nus-3{fill:none;stroke:#014f6d;strokeLinejoin:round;strokeWidth:16px;}\n.nus-3{strokeLinecap:round;}", ""]);
